import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlertNotice } from 'shared/components/index';
import { EventCheckoutModal } from 'features/tc-event-dashboard';
import './TcEventCheckout.scss';

const TcEventCheckout = (props) => {
  const { t } = useTranslation();

  const [checkoutModalOpen, setModalOpen] = useState(false);
  const isEventClosed = !!props.tcEvent.reviewDate;

  const toggleModal = () => {
    setModalOpen(!checkoutModalOpen);
  };

  return (
    <section className="event-checkout-container border-box-radius">
      <div className="h5">{t('tcEventDashboard.checkout.title')}</div>
      {isEventClosed ?
        <>
          <AlertNotice message={t('tcEventDashboard.checkout.complete')} type="success"/>
          <div className="view-details"
                  onClick={() => toggleModal()}>
            {t('tcEventDashboard.checkout.checkoutDetails')}
          </div>
        </>
        : <>
          <div
            dangerouslySetInnerHTML={{ __html: t('tcEventDashboard.checkout.details') }}/>
          <AlertNotice message={t('tcEventDashboard.checkout.warning')} type="warning"
                       noBorder/>
          <button
            className="btn btn-small checkout-btn btn-outline"
            onClick={() => toggleModal()}
          >
            {t('tcEventDashboard.checkout.button')}
          </button>
        </>}
      <EventCheckoutModal
        modalOpen={checkoutModalOpen}
        toggleModal={toggleModal}
        {...props}
      />
    </section>
  );
};

export default TcEventCheckout;

TcEventCheckout.propTypes = {
  tcEvent: PropTypes.shape({}).isRequired,
};
